import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface PersonalInformationModel extends BaseModel {
    accountId: string
    email: string;
    firstName: string;
    lastName: string;
    language: string | null;
    userRoles: string;
    customerAccounts?: DanaUserAccountsModel[] | null;
}
export interface ProfessionalInformationModel extends BaseModel {
    id: string;
    companyName: string;
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    attention: string;
    city: string;
    stateId: string | null;
    countryId: string | null;
    phone: string;
    postalCode: string;
}
export interface DanaUserAccountsModel extends BaseModel {
    id: string;                // Guid in C# maps to string in TypeScript
    userName: string;
    customerNumber: string;
    erpSequence: string;
    firstName: string;
    lastName: string;
    companyName: string;
    approver: string;
    approvalStatus: string;
}
export interface MyProfileModel extends BaseModel {
    personalInformation: PersonalInformationModel;
    professionalInformation: ProfessionalInformationModel;
}
export interface UpdateProfileApiParameter extends PersonalInformationModel, ProfessionalInformationModel {
    canSeePrice?: boolean;
    userName?: string;
}

import {
    ApiParameter,
    API_URL_CURRENT_FRAGMENT,
    get,
    HasPagingParameters,
    patch,

    ServiceResult,
} from "@insite/client-framework/Services/ApiService";
import { State } from "react-inlinesvg";

export interface GetAccountsApiParameter extends ApiParameter, HasPagingParameters {
    searchText?: string;
    expand?: "administration"[];
    additionalExpands?: string[];
    roles?: string[];
    userNames?: string[];
    excludeRoles?: string[];
}

export interface GetAccountApiParameter extends ApiParameter {
    accountId: string;
    approversUsernameFilter?: string;
    numberOfApprovers?: number;
    expand?: ("approvers" | "roles")[];
}

export interface AddAccountApiParameter extends ApiParameter {
    account: Partial<MyProfileModel>;
}

const accountsUrl = "api/v2/dana/myProfile";

export async function getProfile(parameter: GetAccountApiParameter) {

    const accountId = parameter.accountId || API_URL_CURRENT_FRAGMENT;
    const account = await get<MyProfileModel>(`${accountsUrl}`, {
        accountId,
        expand: parameter.expand,
    } as ApiParameter);

    return account;

}

export async function updateProfile(account: UpdateProfileApiParameter) {
    const accountId = account.accountId || API_URL_CURRENT_FRAGMENT;
    const updatedAccount = await patch<MyProfileModel>(`${accountsUrl}/${accountId}`, account);
    return updatedAccount;
}

export async function updateProfileWithResult(
    parameter: UpdateProfileApiParameter,
): Promise<ServiceResult<MyProfileModel>> {
    try {
        const updatedAccount = await updateProfile(parameter);
        return {
            successful: true,
            result: updatedAccount,
        };
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}
export async function updateShowPriceToggleSetting(params: UpdateProfileApiParameter) {
    try {
        await patch<any>(`${accountsUrl}/ToggleShowPriceSetting`, params);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 403 || error.status === 404)) {
            return {
                successful: false,
                errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
                statusCode: error.status,
            };
        }
        throw error;
    }
}

